// type - message part type
export const MESSAGE_PART_TYPE_TEXT = 'text';
export const MESSAGE_PART_TYPE_LINK = 'link';

// type - message types
export const MESSAGE_TYPE_CONTACT_CARD = 'contact_card';
export const MESSAGE_TYPE_GIF = 'gif';
export const MESSAGE_TYPE_IMAGE = 'image';
export const MESSAGE_TYPE_PROFILE = 'profile';
export const MESSAGE_TYPE_SONG = 'song';
export const MESSAGE_TYPE_STICKER = 'sticker';
export const MESSAGE_TYPE_SWIPE_NOTE = 'swipe_note';
export const MESSAGE_TYPE_TEXT = 'text';
export const MESSAGE_TYPE_MEDIA = 'media';
export const MESSAGE_TYPE_TOMBSTONE = 'tombstone';

export const MESSAGE_TYPE_CONTEXTUAL = 'contextual';
export const MESSAGE_TYPE_CONTEXTUAL_LIKE = 'contextual_like';
export const MESSAGE_TYPE_CONTEXTUAL_MESSAGE = 'contextual_message';

export const MESSAGE_TYPE_CONTENT_PROFILE_PHOTO = 'profile_photo';
